// extracted by mini-css-extract-plugin
export var content = "Header-module--content---SXGa";
export var root = "Header-module--root--bRQpA";